import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'
import { reportsConstants } from '../../../../../locale/team'

const RequiredNote = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.color.neutral.color4};
  margin-bottom: 20px;
`

const Asterisk = styled.span`
  color: ${({ theme }) => theme.color.status.danger};
  font-weight: 600;
`

// Role options and note are passed from getRoleFieldsProps, which applies
// permission-based restrictions (e.g. disabling Admin for management viewers).
// This ensures the same permission rules are enforced at the UI level.

type RoleOption = {
  label: string
  value: string
  disabled?: boolean
}

type RoleCardProps = {
  fields: Record<string, any>
  formId: string
  isGroupUser: boolean
  targetEditable: boolean
  roleOptions: RoleOption[]
  roleNote: string
  roleFieldDisabled?: boolean
  testId?: string
}

const RoleCard = ({
  fields,
  formId,
  isGroupUser,
  targetEditable,
  roleOptions,
  roleNote,
  roleFieldDisabled = false,
  testId
}: RoleCardProps) => {
  const { t } = useTranslation('team')

  return (
    <EditProfileCard title={t(reportsConstants.ROLE)} testId={testId}>
      <RequiredNote>
        Required fields are marked with <Asterisk>*</Asterisk>
      </RequiredNote>
      <Suspense fallback={<div>Loading...</div>}>
        <CardFields>
          <Field
            className="role-field"
            formId={formId}
            keys="role"
            label={t(reportsConstants.ROLE)}
            options={roleOptions}
            note={roleNote}
            required
            type="radios"
            values={fields}
            disabled={!targetEditable || roleFieldDisabled}
            data-testid={testId ? `${testId}-role-field` : undefined}
          />
        </CardFields>
      </Suspense>
    </EditProfileCard>
  )
}

export default RoleCard
